export interface Category {
  id: string;
  name: string;
  slug: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  {
    id: 'cat-1',
    name: '动作片',
    slug: 'action',
    icon: 'ri-sword-line',
    description: '热血沸腾的动作电影，枪战、格斗、追逐等精彩场面应有尽有',
  },
  {
    id: 'cat-2',
    name: '喜剧片',
    slug: 'comedy',
    icon: 'ri-emotion-laugh-line',
    description: '轻松搞笑的喜剧电影，让你忘却烦恼开怀大笑',
  },
  {
    id: 'cat-3',
    name: '爱情片',
    slug: 'romance',
    icon: 'ri-heart-line',
    description: '浪漫温馨的爱情故事，感受心动与感动',
  },
  {
    id: 'cat-4',
    name: '科幻片',
    slug: 'scifi',
    icon: 'ri-rocket-line',
    description: '脑洞大开的科幻巨制，探索未来世界与未知宇宙',
  },
  {
    id: 'cat-5',
    name: '恐怖片',
    slug: 'horror',
    icon: 'ri-ghost-line',
    description: '毛骨悚然的恐怖电影，挑战你的胆量极限',
  },
  {
    id: 'cat-6',
    name: '动漫',
    slug: 'anime',
    icon: 'ri-movie-line',
    description: '精选热门动漫作品，二次元世界的精彩冒险',
  },
  {
    id: 'cat-7',
    name: '纪录片',
    slug: 'documentary',
    icon: 'ri-camera-line',
    description: '真实记录的纪录片，探索自然、历史与人文',
  },
  {
    id: 'cat-8',
    name: '电视剧',
    slug: 'tv-series',
    icon: 'ri-tv-line',
    description: '热门电视剧全集，国产剧、韩剧、美剧一网打尽',
  },
  {
    id: 'cat-9',
    name: '综艺',
    slug: 'variety',
    icon: 'ri-mic-line',
    description: '热门综艺节目，搞笑、音乐、真人秀精彩纷呈',
  },
];